export const CATEGORIES = [
  'KVG', 'HOSP', 'ADDITIONAL', 'UPSELL'
]

export const EVENT = {
  DEFAULT_OFFER: 'alva-default-offer',
  MENU_OPEN: 'alva-menu-open',
  NEED_START: 'digitaladvisor-tutorial-start',
}

export const ROUTE_STORAGE = 'ovp-alva-route'

export const CARD_DECK_STATE = {
  FINISHED_ALL: 'finished-all',
  FINISHED_PERSON: 'finished-person',
  OVERVIEW: 'overview',
  QUESTION: 'question',
  SKIPPED: 'skipped',
}

export const NEED_ANSWER = {
  YES: 'yes',
  NO: 'no',
  SKIPPED: 'skipped',
  NOT_ASKED: 'not-asked',
}

export const NEED_CATEGORY = {
  KVG: 'KVG',
  HOSP: 'HOSP',
  AMBULANT: 'AMBULANT',
  DENTAL: 'DENTAL'
}

export const NEED_TYPE = {
  DEFAULT: 'default',
  BELOW_20: 'below20'
}

export const PRODUCT_NEED_BUCKET = {
  BEST_CHOICE: 'bestChoice',
  OTHER: 'other',
}

export const UPSELL_PRODUCT_ID = 'SBVB01Produkt'

export const ROUTE = {
  ROOT: {
    NAME: 'root',
    PATH: '/'
  },

  ENTRY: {
    NAME: 'entry',
    INDEX: 0
  },

  TRIAGE: {
    NAME: 'triage',
    INDEX: 9
  },

  PERSONS: {
    NAME: 'persons',
    INDEX: 10
  },

  PERSONS_IMMIGRANT_PAST: {
    NAME: 'immigrant-past',
    INDEX: 11
  },

  PERSONS_IMMIGRANT_FUTURE: {
    NAME: 'immigrant-future',
    INDEX: 12
  },

  PERSONS_PRODUCT_MAPPING: {
    NAME: 'product-mapping',
    INDEX: 13,
  },

  NEEDS: {
    NAME: 'needs',
    INDEX: 20,
    PATH: 'needs'
  },

  NEEDS_PERSON: {
    NAME: 'needs_person',
    INDEX: 21,
    PATH: 'needs/:personId?'
  },

  PRODUCTS: {
    NAME: 'products',
    INDEX: 30,
  },

  PRODUCTS_KVG: {
    NAME: 'products_kvg',
    INDEX: 31,
    PATH: 'products/KVG/:personId'
  },

  PRODUCTS_HOSP: {
    NAME: 'products_hosp',
    INDEX: 32,
    PATH: 'products/HOSP/:personId'
  },

  PRODUCTS_ADDITIONAL: {
    NAME: 'products_additional',
    INDEX: 33,
    PATH: 'products/ADDITIONAL/:personId'
  },

  PRODUCTS_UPSELL: {
    NAME: 'products_upsell',
    INDEX: 34,
    PATH: 'products/UPSELL/:personId'
  },

  BASKET: {
    NAME: 'basket',
    INDEX: 40
  }
}

export const SOURCE = {
  ENTRY: 'AlvaEntry',
  NUDGE: 'AlvaNudge',
  EXIT: 'AlvaExit',

  PERSON: 'AlvaPersonScreen',
  NEEDS: 'AlvaNeedsScreen',
  PRODUCT: 'AlvaProductScreen',
  BASKET: 'AlvaBasketScreen',
}

export const CardDeckContentEnumType = {
  DEFAULT: 'DEFAULT',
  BELOW_20: 'BELOW_20',
}

export const CardDeckStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
}
